import './addressPicker.scss';

export const AddressPickerComponent = {
    require: {
        editPane: '^^ooEditPane'
    },
    template: `
        <ul>
            <li ng-repeat="address in $ctrl.accountService.data.addresses">
                <label>
                    <input type="radio" name="{{address.name}}" ng-change="$ctrl.selectAddress(address)" ng-model="$ctrl.addressGuid" ng-value="address.guid">
                    <address-card address="address"></address-card>
                </label>
            </li>
            <li ng-if="$ctrl.accountService.data.addresses.length > 0">
                <label>
                    <input
                        type="radio"
                        ng-change="$ctrl.clearAddress()"
                        ng-model="$ctrl.addressGuid"
                        ng-value="null"/> New Address
                </label>
            </li>
        </ul>
        <add-address address="$ctrl.addressService.data" save="optional" ng-if="!$ctrl.addressGuid"></add-address>
    `,
    controller: class {
        constructor(accountService, addressService) {
            'ngInject';
            this.accountService = accountService;
            this.addressService = addressService;
        }

        $onInit() {
            this.accountService.getAddresses();
            this.addressGuid = this.addressService.data.guid;
        }

        selectAddress(address) {
            this.editPane.clearErrors();
            this.addressService.setAddress(address);
        }

        clearAddress() {
            this.editPane.clearErrors();
            this.addressService.clearAddress();
        }
    }
};
